import { render, staticRenderFns } from "./commetReply.vue?vue&type=template&id=61c90be2&scoped=true"
import script from "./commetReply.vue?vue&type=script&lang=js"
export * from "./commetReply.vue?vue&type=script&lang=js"
import style0 from "./commetReply.vue?vue&type=style&index=0&id=61c90be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c90be2",
  null
  
)

export default component.exports